/*
  Die Farben des Textmarkers.

  Warum das hier Farbe sein darf, obwohl die Oberfläche sonst parteineutral
  bleibt: Ein gelber Textmarker ist kein Bekenntnis. Das Zeichensystem ist
  älter und stärker als jede Parteizuordnung, und beim Durchsehen einer
  42-seitigen Vorlage ist es der schnellste Weg, eigene Themen
  auseinanderzuhalten — Verkehr gelb, Umwelt grün, Geld rosa.

  Der Name steht überall dabei, wo die Farbe gewählt wird. Wer Farben nicht
  unterscheiden kann, liest ihn; die Unterstreichung trägt weiterhin die
  fachliche Aussage (weitergegeben oder nur für mich).
*/

export const MARKERFARBEN = [
  { schluessel: "gelb", name: "Gelb" },
  { schluessel: "gruen", name: "Grün" },
  { schluessel: "blau", name: "Blau" },
  { schluessel: "rosa", name: "Rosa" },
  { schluessel: "orange", name: "Orange" },
];

export function farbnameVon(schluessel) {
  const treffer = MARKERFARBEN.find((f) => f.schluessel === schluessel);
  return treffer ? treffer.name : "Gelb";
}

/* Die Farbwähler-Reihe — im Dokumentmodus wie im Pop-up dieselbe. */
export default function Farbwahl({ gewaehlt, aufWahl, beschriftung = "Farbe" }) {
  return (
    <div className="farbwahl" role="group" aria-label={beschriftung}>
      {MARKERFARBEN.map((f) => (
        <button
          key={f.schluessel}
          className={`farbwahl__punkt farbwahl__punkt--${f.schluessel}`}
          aria-pressed={gewaehlt === f.schluessel}
          aria-label={f.name}
          title={f.name}
          onClick={() => aufWahl(f.schluessel)}
        >
          <span className="farbwahl__haken" aria-hidden="true">
            {gewaehlt === f.schluessel ? "\u2713" : ""}
          </span>
        </button>
      ))}
    </div>
  );
}
